import React from 'react'

import Property, { PropertyInfo, PropertyPath } from '../property'
import { PropertyData } from '../../models/properties' 

interface PropertyInfoWindowProps {
  property: PropertyData
  guest: boolean
  compact?: boolean

  actionName?: string
  onAction?: (PropertyData) => void
}

export class PropertyInfoWindow extends React.Component<PropertyInfoWindowProps, {}> {
  static get defaultProps() {
    return {
      compact: false
    }
  }

  render() {
    if (this.props.compact) {
      return <PropertyCompactInfoWindow {...this.props} />
    } else {
      return <PropertyLargeInfoWindow {...this.props} />
    }
  }
}

export class PropertyLargeInfoWindow extends React.Component<PropertyInfoWindowProps, {}> {
  render() {
    const { property, guest, actionName, onAction } = this.props

    return (
      <div className="property-map-info">
        <div>
          <a href={ PropertyPath(property) }>
            <img src={ property.listing_image } width={162} height={214} />
          </a>
        </div>

        <PropertyInfo property={property} guest={guest} actionName={actionName} onAction={onAction} />
      </div>
    )
  }
}

export class PropertyCompactInfoWindow extends React.Component<PropertyInfoWindowProps, {}> {
  render() {
    const { property, guest, actionName, onAction } = this.props

    return (
      <div className="property-map-info property-map-info--compact">
        <div>
          <a href={ PropertyPath(property) }>
            <img src={ property.listing_image } width={106} height={140} />
          </a>
        </div>

        <PropertyInfo property={property} guest={guest} compact={true} actionName={actionName} onAction={onAction} />
      </div>
    )
  }
}